module.exports = __webpack_public_path__ + "img/0.b7f69d25.jpg";